export const serviceName = 'templates';
